import { render } from "./refer-earn.vue?vue&type=template&id=7ed6ec6e"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__